import { useContext } from 'react'
import { db } from '../../firebase/config'
import { SavedIcon } from '../../StateManagment/SavedIcon'
import useAvailableSectors from '../../hooks/useAvailableSectors'
import { getSectorInfo } from '../../helpers/meetstandaard/sectorCatalog'
import toggleSectorSelection from '../../helpers/meetstandaard/toggleSectorSelection'

/**
 * Sector multi-select for Settings → Algemeen. Writes the org's chosen MSI
 * sectors to `CompagnyMeta.SelectedSectors` — the same field onboarding Step 3
 * writes, so the two stay in sync. The selectable list comes from
 * meetstandaard-api (via useAvailableSectors); labels from sectorCatalog.
 *
 * @param {object} props
 * @param {{ docid: string, SelectedSectors?: string[] }} props.comp - the CompagnyMeta doc
 * @param {boolean} props.canEdit - whether the current user may edit settings
 */
const SectorSelector = ({ comp, canEdit }) => {

    const [, setSaved] = useContext(SavedIcon)
    // `selectableSectors`, niet `sectors`: de meetstandaard-api loopt achter op
    // onze eigen sectoren, en zonder de unie met sectorCatalog kan energiearmoede
    // hier niet aangevinkt worden (ADR-031).
    const { selectableSectors: sectors, loading, error } = useAvailableSectors()

    const selected = Array.isArray(comp.SelectedSectors) ? comp.SelectedSectors : []

    const toggle = (slug) => {
        const next = toggleSectorSelection(selected, slug)

        db.collection('CompagnyMeta')
            .doc(comp.docid)
            .update({ SelectedSectors: next })
            .then(() => setSaved('flex'))
    }

    return (
        <div className="dashboard-container logo-container">
            <h2>Sectoren</h2>
            <p className="settings-section-explainer">
                Kies de sector(en) waarin je organisatie actief is. Dit bepaalt welke
                effecten en externe context worden voorgesteld.
            </p>

            {/* De lijst komt pas na de api-fetch. Dit blok staat bovenaan Settings →
                Algemeen, dus zonder gereserveerde hoogte duwt het bij elke load de hele
                pagina omlaag — vandaar min-height op .sector-selector-list. */}
            <div className="sector-selector-list">
                {loading && <p>Sectoren laden…</p>}
                {error && <p className="sector-selector-error">Kon de sectorlijst niet laden: {error}</p>}

                {!loading && !error && sectors.map((slug) => {
                    const info = getSectorInfo(slug)
                    return (
                        <label key={slug} className="sector-selector-row">
                            <input
                                type="checkbox"
                                className="sector-selector-checkbox"
                                checked={selected.includes(slug)}
                                onChange={() => toggle(slug)}
                                disabled={!canEdit}
                            />
                            <span className="sector-selector-label">
                                <strong>{info.label}</strong>
                                {info.description && <span className="sector-selector-desc">{info.description}</span>}
                            </span>
                        </label>
                    )
                })}
            </div>
        </div>
    )
}

export default SectorSelector
